module.exports = __webpack_public_path__ + "img/arrow-clockwise.dc35fa2e.svg";